<div class="min-h-screen bg-base-100 font-body" [attr.data-theme]="darkModeService.darkMode$ | async">
  <app-scroll-progress></app-scroll-progress>
  <app-toaster-container />
  <router-outlet></router-outlet>
</div>
